import { Extension } from '@tiptap/core'
import '@tiptap/extension-text-style'

export const TextColor = Extension.create({
	name: 'textColor',
	addOptions () {
		return {
			types: ['textStyle']
		}
	},
	addGlobalAttributes () {
		return [
			{
				types: this.options.types,
				attributes: {
					textColor: {
						default: null,
						renderHTML: attributes => {
							if (!attributes.textColor) {
								return {}
							}
							return {
								style: `color: ${attributes.textColor}`
							}
						},
						parseHTML: element => ({
							textColor: element.style.color.replace(/['"]+/g, '')
						})
					}
				}
			}
		]
	},
	addCommands () {
		return {
			setTextColor: textColor => ({ chain }) => {
				return chain()
					.setMark('textStyle', { textColor })
					.run()
			},
			unsetTextColor: () => ({ chain }) => {
				return chain()
					.setMark('textStyle', { textColor: null })
					.removeEmptyTextStyle()
					.run()
			}
		}
	}
})
